import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Popper, Paper, Slider, ClickAwayListener } from '@mui/material';
import { OmakasePlayer } from '@byomakase/omakase-player';

type VolumeControllerProps = {
  player: OmakasePlayer | null;
};

const VolumeController = ({ player }: VolumeControllerProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const [volume, setVolume] = useState<number>(100);

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    const target = e.currentTarget as HTMLElement;
    if (anchorEl && anchorEl === target) {
      setAnchorEl(null);
    } else {
      setAnchorEl(target);
    }
  };

  const handleClose = () => setAnchorEl(null);

  const handleChange = (e: Event, value: number | number[]) => {
    const val = Array.isArray(value) ? value[0] : value;
    setVolume(Number(val));
    try {
      if (player && player.video && typeof (player.video as any).setVolume === 'function') {
        (player.video as any).setVolume(Number(val) / 100)?.subscribe?.(() => {});
      }
    } catch (err) {
      console.error('Error setting volume', err);
    }
  };

  return (
    <>
      <ControlItem>
        <ControlImage onClick={handleClick} src="/images/video-player/volume.svg" alt="" />
      </ControlItem>
      <Popper open={open} anchorEl={anchorEl} placement="top" disablePortal>
        <ClickAwayListener onClickAway={handleClose}>
          <Paper elevation={3} sx={{ p: 1, display: 'flex', alignItems: 'center', height: 140 }}>
            <Slider
              orientation="vertical"
              value={volume}
              onChange={handleChange}
              min={0}
              max={100}
              aria-label="Volume"
              sx={{ height: 120 }}
            />
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default VolumeController;

const ControlItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ControlImage = styled.img`
  cursor: pointer;
`;